import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

const DEFERRED_DATE_VALUE = 'DEFERRED';

@Pipe({
  name: 'dateToString',
})
export class DateToStringPipe implements PipeTransform {
  datePipe = new DatePipe('en-UK');

  transform(date?: NgbDate | string): string {
    if (date === DEFERRED_DATE_VALUE) {
      return 'Deferred';
    }

    if (typeof date === 'string' && date.trim().length) {
      try {
        return this.datePipe.transform(date, 'dd/MM/yyyy');
      } catch (error) {
        return '-';
      }
    }

    if (typeof date === 'object' && date) {
      const { day, year, month } = date;
      const objDate = new Date(year, month - 1, day);

      // check if objDate is `Invalid Date`
      if (isNaN(objDate.getTime())) {
        return '-';
      }

      return this.datePipe.transform(objDate, 'dd/MM/yyyy');
    }

    return '-';
  }
}
